import { ProductType } from 'src/modules/common/common-types';

export const WaitingForActionHeaders = {
	[ProductType[ProductType.Returns]]: 'REVIEW & SIGN TAX RETURNS',
	[ProductType[ProductType.Extensions]]: 'REVIEW & SIGN TAX RETURN EXTENSIONS',
	[ProductType[ProductType.Gather]]: 'COMPLETE GATHER REQUEST',
	[ProductType[ProductType.Organizers]]: 'COMPLETE TAX ORGANIZER',
};
